import React from 'react';
import { Stack } from '@starrez/starryui9';
import { ICellRenderer } from '../types';
import { AvatarThumbnail } from '@starryui10/avatar/AvatarThumbnail';

export interface IPhotoColumnProps extends ICellRenderer<avatar.IAvatarThumbnailProps> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatData: (data: any) => avatar.IAvatarThumbnailProps;
}

export const PhotoColumn = (props: IPhotoColumnProps) => {
    return (
        <Stack height="100%">
            <AvatarThumbnail size="Smallest" {...(props.formatData ? props.formatData(props.data) : props.value)} />
        </Stack>
    );
};

export function usePhotoColumn<TRowData>(formatData: (data: TRowData) => avatar.IAvatarThumbnailProps) {
    return {
        cellRendererFramework: PhotoColumn,
        cellRendererParams: {
            formatData,
        },
    };
}
